
namespace TabAurous.Sales {
    import fld = SalesItemsBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class SalesItemsBOMEditor extends _Ext.BOMGridEditor<SalesItemsBOMRow> { 
        protected getDialogType() { return SalesItemsBOMDialog; }
        protected getLocalTextPrefix() { return SalesItemsBOMRow.localTextPrefix; }



        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as SalesItemsDialog).CalculateTotals();
                }
            });
        } 
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        } 
    }
}